module.exports = __webpack_public_path__ + "static/media/canteen.3de7e9fa.png";